import SidebarAdmin from "./sidebar-admin";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useState } from "react";
import { API_URL } from "../config";

const AddClient = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    type: "individual" as "individual" | "company",
    companyName: "",
    country: "",
    email: "",
    phone: "",
    address: "",
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const setType = (type: "individual" | "company") => {
    setFormData((prev) => ({ ...prev, type }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const clientData = {
        firstname: formData.firstname,
        lastname: formData.lastname,
        type: formData.type,
        country: formData.country,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        company_name: formData.type === "company" ? formData.companyName : null,
      };
      await axios.post(`${API_URL}/create-client`, clientData);
      navigate("/admin/list-clients");
      toast.success("Client created successfully");
    } catch (error: any) {
      console.error("Erreur création client :", error);
      if (error.response?.data?.errors) {
        const validationErrors = error.response.data.errors;
        Object.keys(validationErrors).forEach((field) => {
          toast.error(`${field}: ${validationErrors[field][0]}`);
        });
      } else {
        toast.error(error.response?.data?.message || "Error creating client");
      }
    }
  };

  const handleCancel = () => navigate("/admin/list-clients");

  return (
    <>
      <style>{`
        /* Type toggle — same height as inputs, compact */
        .acp-type {
          display: inline-flex;
          border: 1px solid #e2e8f0;
          border-radius: 7px;
          overflow: hidden;
          height: 38px;
        }
        .acp-type button {
          display: flex;
          align-items: center;
          gap: 7px;
          border: none;
          background: #fff;
          color: #64748b;
          font-size: 13px;
          font-weight: 500;
          padding: 0 16px;
          cursor: pointer;
          transition: background .15s ease, color .15s ease;
        }
        .acp-type button + button { border-left: 1px solid #e2e8f0; }
        .acp-type button i { font-size: 11.5px; opacity: .7; }
        .acp-type button:hover { background: #f8fafc; }
        .acp-type button.on { background: #294b5a; color: #fff; }
        .acp-type button.on i { opacity: 1; color: #d3be76; }

        .acp-section + .acp-section {
          margin-top: 28px;
          padding-top: 28px;
          border-top: 1px solid #f1f3f6;
        }
        .acp-section-label {
          font-size: 12px;
          font-weight: 600;
          color: #4a5568;
          margin-bottom: 16px;
        }

        .acp-field label {
          display: block;
          font-size: 12.5px;
          font-weight: 500;
          color: #4a5568;
          margin-bottom: 6px;
        }
        .acp-field input {
          width: 100%;
          height: 38px;
          padding: 0 12px;
          font-size: 13.5px;
          color: #1a202c;
          border: 1px solid #dde3ea;
          border-radius: 7px;
          background: #fff;
          transition: border-color .15s ease, box-shadow .15s ease;
        }
        .acp-field input::placeholder { color: #b0b9c4; font-size: 13px; }
        .acp-field input:focus {
          outline: none;
          border-color: #294b5a;
          box-shadow: 0 0 0 3px rgba(41,75,90,.08);
        }

        .acp-btn {
          height: 38px;
          padding: 0 20px;
          font-size: 13px;
          font-weight: 500;
          border-radius: 7px;
          cursor: pointer;
          border: none;
          display: inline-flex;
          align-items: center;
          gap: 7px;
          transition: background .15s ease, border-color .15s ease;
        }
        .acp-btn--ghost { background: #fff; color: #4a5568; border: 1px solid #dde3ea; }
        .acp-btn--ghost:hover { background: #f8fafc; }
        .acp-btn--primary { background: #294b5a; color: #fff; }
        .acp-btn--primary:hover { background: #1e3946; }
        .acp-btn--primary i { color: #d3be76; font-size: 11px; }

        /* Right-column info panel */
        .acp-info-item {
          display: flex;
          gap: 12px;
          padding: 14px 0;
        }
        .acp-info-item + .acp-info-item { border-top: 1px solid #f1f3f6; }
        .acp-info-icon {
          width: 30px;
          height: 30px;
          border-radius: 8px;
          background: rgba(211, 190, 118, 0.14);
          color: #b09a50;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12.5px;
          flex-shrink: 0;
        }
        .acp-info-item h4 {
          font-size: 13px;
          font-weight: 600;
          color: #1a202c;
          margin-bottom: 3px;
        }
        .acp-info-item p {
          font-size: 12.5px;
          color: #94a3b8;
          line-height: 1.55;
        }
      `}</style>

      <div className="dashboard-layout">
        <aside className="dashboard-sidebar">
          <SidebarAdmin />
        </aside>

        <div className="dashboard-main">
          <header className="dashboard-header">
            <div className="header-content">
              <button className="menu-toggle">
                <i className="icon-menu-2 text-20"></i>
              </button>
            </div>
          </header>

          <main className="dashboard-content">
            <div className="dashboard__content bg-light-2 p-20">
              {/* Page header — same convention as Dashboard */}
              <div className="row y-gap-20 justify-between items-end pb-10 lg:pb-40 md:pb-32">
                <div className="col-12">
                  <div className="text-13 text-muted mb-5">
                    <Link to="/admin/list-clients" style={{ color: "#94a3b8", textDecoration: "none" }}>Clients</Link>
                    <span className="mx-5">/</span>
                    <span>Add new</span>
                  </div>
                  <h1 className="text-24 fw-600" style={{ color: "#1e293b" }}>Add a new client</h1>
                  <p className="text-14 mt-5" style={{ color: "#64748b" }}>
                    Create a client profile to start booking tours, visas or car rentals for them.
                  </p>
                </div>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="row y-gap-30">
                  {/* Main form column */}
                  <div className="col-xl-8 col-12">
                    <div className="py-30 px-30 rounded-4 bg-white shadow-3 mb-3">
                      <div className="acp-section">
                        <div className="acp-section-label">Client type</div>
                        <div className="acp-type">
                          <button type="button" className={formData.type === "individual" ? "on" : ""} onClick={() => setType("individual")}>
                            <i className="fas fa-user"></i>
                            Individual
                          </button>
                          <button type="button" className={formData.type === "company" ? "on" : ""} onClick={() => setType("company")}>
                            <i className="fas fa-building"></i>
                            Company
                          </button>
                        </div>
                      </div>

                      <div className="acp-section">
                        <div className="acp-section-label">Identity</div>
                        <div className="row x-gap-20 y-gap-20">
                          {formData.type === "company" && (
                            <div className="col-12 acp-field">
                              <label htmlFor="companyName">Company name</label>
                              <input id="companyName" name="companyName" placeholder="e.g. Al Falaj Trading LLC" value={formData.companyName} onChange={handleInputChange} required />
                            </div>
                          )}
                          <div className="col-md-6 col-12 acp-field">
                            <label htmlFor="firstname">First name</label>
                            <input id="firstname" name="firstname" placeholder="e.g. Ahmed" value={formData.firstname} onChange={handleInputChange} required />
                          </div>
                          <div className="col-md-6 col-12 acp-field">
                            <label htmlFor="lastname">Last name</label>
                            <input id="lastname" name="lastname" placeholder="e.g. Al Balushi" value={formData.lastname} onChange={handleInputChange} required />
                          </div>
                        </div>
                      </div>

                      <div className="acp-section">
                        <div className="acp-section-label">Contact</div>
                        <div className="row x-gap-20 y-gap-20">
                          <div className="col-md-6 col-12 acp-field">
                            <label htmlFor="email">Email</label>
                            <input id="email" name="email" type="email" placeholder="name@email.com" value={formData.email} onChange={handleInputChange} required />
                          </div>
                          <div className="col-md-6 col-12 acp-field">
                            <label htmlFor="phone">Phone</label>
                            <input id="phone" name="phone" placeholder="+968 9xxx xxxx" value={formData.phone} onChange={handleInputChange} required />
                          </div>
                        </div>
                      </div>

                      <div className="acp-section">
                        <div className="acp-section-label">Location</div>
                        <div className="row x-gap-20 y-gap-20">
                          <div className="col-md-6 col-12 acp-field">
                            <label htmlFor="address">Address</label>
                            <input id="address" name="address" placeholder="Street, city" value={formData.address} onChange={handleInputChange} required />
                          </div>
                          <div className="col-md-6 col-12 acp-field">
                            <label htmlFor="country">Country</label>
                            <input id="country" name="country" placeholder="e.g. Oman" value={formData.country} onChange={handleInputChange} required />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Actions — own card, matching original page convention */}
                    <div className="py-20 px-30 rounded-4 bg-white shadow-3">
                      <div className="d-flex justify-end" style={{ gap: 10 }}>
                        <button type="button" onClick={handleCancel} className="acp-btn acp-btn--ghost">
                          Cancel
                        </button>
                        <button type="submit" className="acp-btn acp-btn--primary">
                          <i className="fas fa-check"></i>
                          Save client
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Context panel */}
                  <div className="col-xl-4 col-12">
                    <div className="py-30 px-30 rounded-4 bg-white shadow-3">
                      <h2 className="text-16 fw-600 mb-10" style={{ color: "#1e293b" }}>Before you save</h2>
                      <div className="acp-info-item">
                        <div className="acp-info-icon"><i className="fas fa-id-card"></i></div>
                        <div>
                          <h4>Use the legal name</h4>
                          <p>Match the name to the client's ID or passport — it carries through to bookings and invoices.</p>
                        </div>
                      </div>
                      <div className="acp-info-item">
                        <div className="acp-info-icon"><i className="fas fa-envelope-open-text"></i></div>
                        <div>
                          <h4>Email is required</h4>
                          <p>Booking confirmations, visa updates and invoices are sent here automatically.</p>
                        </div>
                      </div>
                      <div className="acp-info-item">
                        <div className="acp-info-icon"><i className="fas fa-building"></i></div>
                        <div>
                          <h4>Company accounts</h4>
                          <p>You'll be able to link multiple travelers to a company profile after saving.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </main>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default AddClient;